import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { CmsEntities } from 'client/data/models/cms';
import { getFullImageUrl, getStaticImageUrl } from 'client/utils/image-helpers';
import { HtmlVideoPlayer } from 'site-modules/shared/components/html-video-player/html-video-player';

import './hero-content.scss';

export function HeroContent({
  entry,
  className = null,
  logoSrc = null,
  alt,
  heroSize,
  isMobile = false,
  children = null,
  tag = 'div',
  mobileUsePhoto = true,
  playsInline = false,
  imgHeight = null,
  imgWidth = null,
  logoHeight = null,
  logoWidth = null,
  fetchpriority = 'auto',
}) {
  const videoUrl = entry.metadata('videoURL').value();
  const photoUrlLg = entry.metadata('heroLgURL').value() || get(entry.links(), '[0].href');
  const photoUrlSm = entry.metadata('heroSmURL').value() || get(entry.links(), '[0].href');
  const photoUrl = isMobile ? photoUrlSm : photoUrlLg;

  const isVideo = (!isMobile || !mobileUsePhoto) && videoUrl;
  const isPhoto = ((isMobile && mobileUsePhoto) || !videoUrl) && photoUrl;

  const Tag = tag;

  const SubTag = tag === 'figure' ? 'figcaption' : 'div';
  if (!(isVideo || isPhoto)) {
    return null;
  }

  return (
    <Tag className={classnames('hero-content pos-r', className, { 'img-wrapper': isPhoto })}>
      {isVideo && (
        <HtmlVideoPlayer
          className="w-100 rounded"
          src={getStaticImageUrl(videoUrl)}
          autoPlay
          loop
          controls
          playsInline={playsInline}
        />
      )}
      {isPhoto && (
        <img
          className={classnames('w-100', { rounded: !isMobile })}
          src={getFullImageUrl(photoUrl, heroSize)}
          alt={alt}
          height={imgHeight || null}
          width={imgWidth || null}
          fetchPriority={fetchpriority}
        />
      )}
      {!!logoSrc && !children && (
        <img
          className="logo mt-1 ms-0_5 mt-md-1_5 ms-md-1_5"
          src={getStaticImageUrl(logoSrc)}
          alt={`${alt} logo`}
          height={logoHeight || null}
          fetchPriority={fetchpriority}
        />
      )}
      {!!children && (
        <SubTag className="hero-content-caption">
          {!!logoSrc && (
            <img
              src={getStaticImageUrl(logoSrc)}
              alt={`${alt} logo`}
              height={logoHeight || null}
              width={logoWidth || null}
              fetchPriority={fetchpriority}
            />
          )}
          {children}
        </SubTag>
      )}
    </Tag>
  );
}

HeroContent.propTypes = {
  entry: CmsEntities.Content.isRequired,
  alt: PropTypes.string.isRequired,
  heroSize: PropTypes.number.isRequired,
  className: PropTypes.string,
  logoSrc: PropTypes.string,
  isMobile: PropTypes.bool,
  children: PropTypes.node,
  tag: PropTypes.string,
  mobileUsePhoto: PropTypes.bool,
  playsInline: PropTypes.bool,
  imgHeight: PropTypes.string,
  imgWidth: PropTypes.string,
  logoHeight: PropTypes.string,
  logoWidth: PropTypes.string,
  fetchpriority: PropTypes.string,
};
